import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Box, Row, Spacing } from 'seagull';
import styles from './ConfidenceBars.module.scss';
import { CONFIDENCE_BARS, filledConfidenceBars } from './ConfidenceBars.utils';
export const ConfidenceBars = (param)=>{
    let { band, label, testId } = param;
    const filledBars = filledConfidenceBars(band);
    return /*#__PURE__*/ _jsx(Row, {
        gap: Spacing.Space2,
        alignItems: "end",
        className: styles.bars,
        role: "img",
        "aria-label": label,
        testId: testId,
        children: CONFIDENCE_BARS.map((bar, index)=>/*#__PURE__*/ _jsx(Box, {
                className: cn(styles.bar, styles[bar], {
                    [styles.filled]: index < filledBars
                })
            }, bar))
    });
};
